import { render, staticRenderFns } from "./AddAvailability.vue?vue&type=template&id=71fa4810"
import script from "./AddAvailability.vue?vue&type=script&lang=js"
export * from "./AddAvailability.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports